import { FavouriteDataAdapter } from './favourite-data-adapter';
import { setTickInterval } from './utils';

/**
 * Calculates number of rows in chart for given column
 * @param options 
 * @param dataAdapter 
 * @param axisColumn 
 */
export const getNumberOfRows = (options: Highcharts.Options, dataAdapter: FavouriteDataAdapter, axisColumn: number) => {

  let numberOfCategories = dataAdapter.hasCategories(axisColumn)
    ? dataAdapter.columnCategories[axisColumn].length
    : 0;

  const { columns, rows } = dataAdapter.dataModel;

  if (numberOfCategories === 0 && rows
    && columns && columns[axisColumn] && columns[axisColumn].dataType === 'Date') {

    const rowsWithValues = rows.filter(row => row[axisColumn] && row[axisColumn].value);

    if (rowsWithValues.length > 1) {

      const firstRowValue = rowsWithValues[0][axisColumn].value;
      const lastRowValue = rowsWithValues[rowsWithValues.length - 1][axisColumn].value;

      numberOfCategories = Math.ceil((lastRowValue - firstRowValue) / setTickInterval(columns[axisColumn].period));
    }
  }

  const stacking = options.plotOptions
    && options.plotOptions.bar
    && (options.plotOptions as any).stacking !== null;

  const numberOfSeries = stacking ? 1 : options.series.length;

  return numberOfCategories * numberOfSeries;
};
